import React from 'react';

import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import {Collections, Objects} from "components";

import {Button} from 'reactstrap';
import UniversalModalOverride from "components/UniversalModalOverride";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Types from "../../../../../constants/Types";


const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Acquisitions',
		url: '/acquisitions',
		icon: 'download',
	},
	{
		name: 'Imports',
		url: '/acquisitions/imports',
		icon: 'usd',
	}
];

export default class Imports extends Framework.Components.View {
	constructor(props) {
		super(props, 'imports');
		this.state.backdrop = true;
		this.state.modalImporter = false;
		this.state.closeModal = 0;
		this.state.bypass = false;
	}

	handlingToggle = () => {
		if (this.state.backdrop !== 'static'){
			this.setState({modalImporter: !this.state.modalImporter});
		} else {
			if (this.state.closeModal > 0 || this.state.bypass){
				this.setState({closeModal: 0});
				this.setState({backdrop: true});
				this.setState({modalImporter: !this.state.modalImporter});
			} else {
				this.setState({closeModal: 1});
				API.Toast.info('You have unsaved changes. Click again to close modal.', {
					position: API.Toast.POSITION.TOP_CENTER,
					autoClose: 4000
				});
			}
		}
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button onClick={this.toggle('modalForm3A')} size="sm" color="primary">
						<i className="fa fa-barcode"/>&nbsp;&nbsp;Generate Form 6A
					</Button>
					<Button onClick={this.toggle('modalForm3C')} size="sm" color="primary">
						<i className="fa fa-barcode"/>&nbsp;&nbsp;Generate Form 6C
					</Button>
					<Button onClick={this.toggle('modalImporter')} size="sm" color="primary">
						<i className="fa fa-train"/>&nbsp;&nbsp;Add Imported Acquisition
					</Button>
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Imports" value="imports"/>
					<Tab label="Forms" value="forms"/>
				</Tabs>

				<div style={{display: this.state.tab === 'imports' ? 'block' : 'none'}}>
					<Collections.Imports
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						locations={this.props.locations}
						states={this.props.states}
					/>
				</div>
				{this.state.tab === 'forms' &&
					<Collections.Forms
						parent={this.props.match.params.id}
						forForm={Types.Importers_Forms._name}
						url="/importers/forms"
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>}

				{/*Don't pass toggle if passing showModal*/}
				<UniversalModalOverride
					showModal={this.state.modalImporter}
					locations={this.props.locations}
					states={this.props.states}
					name={"Acquisition"}
					object={Objects.Acquisition}
					history={this.props.history}
					reportClose={this.reportClose('modalImporter')}
					afterSave={() => {this.setState({bypass: false})}}
					handleToggle={this.handlingToggle}
					size={'xl'}
					objectProps={{
						modalState: this.state['modalImporter'],
						setBackdrop: (backdrop) => this.setState({backdrop}),
						setBypass: (bypass) => this.setState({bypass})
					}}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					title={"ATF Form (5330.3A) 6"}
					name={'ATF Form (5330.3A) '}
					object={Objects.FormSix3A}
					toggle={this.state['modalForm3A']}
					reportClose={this.reportClose('modalForm3A')}
					size={'xl'}
					submitLabel={"Generate Form (5330.3A)"}
				/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					history={this.props.history}
					name={"ATF Form (5330.3A)"}
					title={"ATF Form (5330.3C) 6"}
					object={Objects.FormSix3C}
					toggle={this.state['modalForm3C']}
					reportClose={this.reportClose('modalForm3C')}
					size={'xl'}
					submitLabel={"Generate Form (5330.3C)"}
				/>
			</div>
		);
	}
}
